import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/lib/content";
import { Eyebrow, MaskLines, Reveal } from "@/components/site/Motion";
import { scrollToId, EASE_OUT } from "@/lib/scroll";

const ServiceCard = ({ s, i }) => {
  const onMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    e.currentTarget.style.setProperty("--mx", `${e.clientX - r.left}px`);
    e.currentTarget.style.setProperty("--my", `${e.clientY - r.top}px`);
  };
  return (
    <motion.article
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, delay: (i % 3) * 0.1, ease: EASE_OUT }}
      onMouseMove={onMove}
      onClick={() => scrollToId("devis")}
      className={`spot-card group relative min-h-[300px] lg:min-h-0 overflow-hidden rounded-3xl border border-white/10 bg-[#0c1222] cursor-pointer ${s.span}`}
      data-testid={`service-card-${s.key}`}
    >
      <img
        src={s.img}
        alt={s.title}
        loading="lazy"
        className="absolute inset-0 h-full w-full object-cover grayscale-[70%] brightness-[0.55] scale-105 transition-[transform,filter] duration-[1200ms] ease-out group-hover:scale-110 group-hover:grayscale-0 group-hover:brightness-[0.7]"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#050811] via-[#050811]/50 to-transparent" />
      <div className="relative z-[3] flex h-full flex-col justify-between p-6 sm:p-8">
        <div className="flex items-start justify-between">
          <span className="font-mono-uc text-xs tracking-[0.2em] text-cyan-300">0{i + 1}</span>
          <span className="flex h-11 w-11 items-center justify-center rounded-full border border-white/20 bg-[#050811]/40 backdrop-blur-md text-white transition-[background-color,color,transform] duration-500 group-hover:bg-[#0af5f0] group-hover:text-[#050811] group-hover:rotate-45">
            <ArrowUpRight className="h-5 w-5" />
          </span>
        </div>
        <div>
          <h3 className="font-display text-2xl sm:text-3xl font-semibold text-white">{s.title}</h3>
          <p className="mt-3 max-w-md text-sm sm:text-base text-slate-300 leading-relaxed">{s.text}</p>
        </div>
      </div>
    </motion.article>
  );
};

export default function Services() {
  return (
    <section id="services" className="relative py-24 sm:py-36" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-8 items-end mb-14 sm:mb-20">
          <div className="lg:col-span-7">
            <Eyebrow index="01">Nos prestations</Eyebrow>
            <h2 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight text-white leading-[1.02]">
              <MaskLines inView lines={["Chaque surface,", <span key="a" className="font-serif-i text-brand">traitée avec soin.</span>]} />
            </h2>
          </div>
          <Reveal className="lg:col-span-5" delay={0.2}>
            <p className="text-base sm:text-lg text-slate-300 leading-relaxed">
              Du petit cabinet au bâtiment complet, UNDERCLEAN intervient sur tous vos espaces professionnels,
              en ponctuel ou en contrat d'entretien régulier.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 lg:auto-rows-[280px] gap-5">
          {SERVICES.map((s, i) => (
            <ServiceCard key={s.key} s={s} i={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
